import { render, staticRenderFns } from "./KYC_v2.vue?vue&type=template&id=6f722484&scoped=true&"
import script from "./KYC_v2.vue?vue&type=script&lang=js&"
export * from "./KYC_v2.vue?vue&type=script&lang=js&"
import style0 from "./KYC_v2.vue?vue&type=style&index=0&id=6f722484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f722484",
  null
  
)

export default component.exports